import { render, staticRenderFns } from "./TopicModal.vue?vue&type=template&id=72f584f9"
import script from "./TopicModal.vue?vue&type=script&lang=js"
export * from "./TopicModal.vue?vue&type=script&lang=js"
import style0 from "./TopicModal.vue?vue&type=style&index=0&id=72f584f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports